import React from 'react';
import { Box, PaddingSize } from '@styleseat/ui';

import { ISearchTile } from '../SearchTile/SearchTile.types';
import SearchTile from '../SearchTile/SearchTile';

export type SearchTileLineProps = {
  onPress?: (tile: ISearchTile) => void;
  tiles: ISearchTile[];
  imageHeight: number;
  imageWidth: number;
  space?: PaddingSize;
};

/**
 * Displays a clickable image with text beneath
 */
export const SearchTilesLine = ({
  onPress = () => {},
  tiles,
  imageHeight,
  imageWidth,
}: SearchTileLineProps) => (
  <Box
    width="100%"
    style={{
      flexDirection: 'row',
    }}
  >
    {tiles.map((tile, idx) => (
      <Box
        key={tile.text}
        paddingLeft={idx === 0 ? 0 : '1%'}
        paddingRight={idx === tiles.length - 1 ? 0 : '1%'}
        flex={1}
      >
        <SearchTile
          {...tile}
          imageHeight={imageHeight}
          imageWidth={imageWidth}
          onPress={() => onPress(tile)}
        />
      </Box>
    ))}
  </Box>
);
